import React from "react";
import $ from 'jquery';
import Stock from '../services/stock';
import AuthorizationCheck from '../auth/authorizationCheck';
import { Button } from "bootstrap";
import Utility from "../utilities/utility";

class StockProducts extends React.Component {


    constructor() {

        super();

        this.stockService = new Stock();

        this.state = {
            productList: [],
            currentUserRole: '',
            timeoutId: null
        }
    }

    componentDidMount() {

        this.products();
    }

    setRole = (role) => {

        this.setState({ currentUserRole: role });
    }

    products = async () => {

        let name = $('#name').val();
        let model = $('#model').val();
        let brand = $('#brand').val();
        let size = $('#size').val();
        let supplierUniqueId = $('#cpid').val();

        try {
            const response = await this.stockService.productList(name, model, brand, size, supplierUniqueId);

            this.setState({ productList: await response.json() });


        } catch (error) {
            console.log(error)
        }



    }

    searchProduct = () => {

        let timer;

        clearTimeout(this.state.timeoutId);

        timer = setTimeout(() => {
            this.products();
        }, 1500);

        this.setState({ timeoutId: timer })
    }

    addProduct = async (e, product) => {

        e.preventDefault();

        let productId = product.id;
        let messageHolder = 'product-messageHolder-' + product.id;

        let quantity = $('#product-quantity-' + productId).val();

        if (Utility.isEmpty(productId) || Utility.isEmpty(quantity)) {

            Utility.showAlertWithId(messageHolder, 'Veillez entrer les informations requises', 'danger', true);

            return;
        }
        try {
            const response = await this.stockService.addProduct(productId, quantity);

            if (response.ok) {

                Utility.showAlertWithId(messageHolder, 'Operation Aboutie', 'success', true);
                let eqty = $('#prod-qty-' + productId).html();
                let nqty = !Utility.isEmpty(eqty) ? parseInt(eqty) + (parseInt(quantity)) : quantity;
                $('#prod-qty-' + productId).html(nqty);

                console.log(product.quantity);
                return;
            }

            Utility.showAlertWithId(messageHolder, 'Operation non Aboutie', 'danger', true);


        } catch (error) {
            Utility.showAlertWithId(messageHolder, 'Operation non Aboutie', 'danger', true);

        }



    }

    render() {


        const productList = this.state.productList;



        return (


            <div className="container">

                <AuthorizationCheck accessLevel='USER' userRole={this.setRole} />

                <div className="supplier-wrapper mt-4">

                    <h2 className="text-center">List de Produits</h2>


                    <div className="form-wrapper">
                        <div className="row">
                            <div className="col">


                                <div className="form-group">
                                    <input className="form-control" id="name" placeholder="Nom" onKeyUp={this.searchProduct} />
                                </div>
                            </div>
                            <div className="col">
                                <div className="form-group">
                                    <input className="form-control" id="model" placeholder="Model" onKeyUp={this.searchProduct} />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">

                                <div className="form-group">
                                    <input className="form-control" id="brand" placeholder="Marque" onKeyUp={this.searchProduct} />
                                </div>
                            </div>
                            <div className="col">
                                <div className="form-group">
                                    <input className="form-control" id="size" placeholder="Numero" onKeyUp={this.searchProduct} />
                                </div>
                            </div>

                            <div className="col">
                                <div className="form-group">
                                    <input className="form-control" id="cpid" placeholder="CPID" onKeyUp={this.searchProduct} />
                                </div>
                            </div>
                        </div>




                    </div>

                    <div className="card card-default mt-2 bg-primary text-white">



                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-4">Description</div>
                                <div className="col"></div>
                                <div className="col">Quantité</div>
                                <div className="col"></div>


                            </div>
                        </div>

                    </div>

                    {productList.length > 0 && productList.map(product => {

                        let addProductSection = '';

                        if(this.state.currentUserRole == 'MANAGER' || this.state.currentUserRole == 'SUPER-ADMIN'){

                            addProductSection = <div className="row">

                            <div className="col">
                                <input className="form-control" id={"product-quantity-" + product.id} placeholder="Quantité" />
                            </div>

                            <div className="col">
                                <button className="btn btn-primary btn-xs" onClick={(e) => this.addProduct(e, product)}>Ajoute</button>
                            </div>
                        </div>;
                        }



                        return <div className="card card-default mt-2" key={product.id}>

                            <div className="card-body" id={"product-messageHolder-" + product.id}>
                                <div className="row">
                                    <div className="col-md-4">{product.name} {product.model} {product.brand} {product.color} {product.size} </div>
                                    <div className="col">
                                        <div>CBM: {product.cbm}</div>
                                        <div>POIDS: {product.weight}</div>
                                        <div>CPID: {product.supplierUniqueId}</div>
                                    </div>
                                    <div className="col" id={"prod-qty-" + product.id}>{product.quantity}</div>
                                    <div className="col">
                                        
                                    { addProductSection }

                                    </div>

                                    

                                </div>
                            </div>

                        </div>

                    }


                    )}

                </div>
            </div>



        );

    }

}

export default StockProducts;